import { AxiosError } from 'axios'
import { StoreonModule } from 'storeon'
import { toast } from 'react-toastify'
import { Events, State } from '@/interfaces'
import { objectKeys } from '@/utils'

import { api } from '@/api'

interface IFlyingListError {
  date?: string[]
  entries?: string[]
  fly_session_minutes?: string[]
}

export const flyingListModule: StoreonModule<State, Events> = (store) => {
  store.on('@init', () => ({
    flyingList: [],
    instructors: [],
    instructorOptions: [],
    dateFlyingList: new Date(),
  }))

  store.on('flyingList/save', (_state, event) => {
    return {
      flyingList: event
    }
  })

  store.on('setFlyingListDate', (_state, event) => {
    return {
      dateFlyingList: event
    }
  })

  store.on('instructors/save', (_state, event) => {
    const instructorOptions = event.map((instructor) => ({
      value: instructor.title,
      label: instructor.title
    }))

    return {
      instructors: event,
      instructorOptions: [
        {
          value: null,
          label: '-'
        },
        ...instructorOptions
      ]
    }
  })

  store.on('flyingList/clear', () => {
    return {
      flyingList: []
    }
  })

  store.on('flyingList/get', async (_state, event) => {
    try {
      const data = await api.flyingList.getFlyingList(event)
      store.dispatch('flyingList/save', data)
    } catch {
      toast.error('Не удалось получить расписание полетного листа')
    }
  })

  store.on('flyingListEntry/update', async (state, event) => {
    try {
      const flyingEntry = await api.flyingList.updateFlyingListEntry(event.id, event.params)
      const intervalItem = state.flyingList.map((flyingListItem) => {
        if (flyingListItem.id !== event.intervalId) {
          return flyingListItem
        }

        const entries = flyingListItem.fly_list_entries.map((entry) => {
          return entry.id === event.id ? flyingEntry : entry
        })

        return {
          ...flyingListItem,
          fly_list_entries: entries
        }
      })
      store.dispatch('flyingList/save', intervalItem)
    } catch (error: unknown) {
      const { response } = error as AxiosError<IFlyingListError>
      if (response === undefined) return
      const keys = objectKeys<IFlyingListError>(response.data)
      keys.forEach(key => {
        toast.error(response.data?.[key]?.[0])
      });
    }
  })

  store.on('flyingListTimeIntervals/update', async (state, event) => {
    try {
      const data = await api.flyingList.updateFlyingListTimeIntervals(event.id, event.params)
      const updatedFlyingList = state.flyingList.map((flyingList) =>
        flyingList.id === event.id ? data : flyingList
      )
      store.dispatch('flyingList/save', updatedFlyingList)
    } catch {
      toast.error('Не удалось изменить дату расписания полетного листа')
    }
  })

  store.on('instructors/get', async () => {
    try {
      const data = await api.flyingList.getInstructors()
      store.dispatch('instructors/save', data)
    } catch {
      toast.error('Не удалось получить список инструкторов и котроллеров')
    }
  })
}
